//@flow
export const CREATE_REQUESTED = "projectPermissions/CREATE_REQUESTED";
export const CREATE_COMPLETED = "projectPermissions/CREATE_COMPLETED";
export const CREATE_FAILED = "projectPermissions/CREATE_FAILED";

export const UPDATE_REQUESTED = "projectPermissions/UPDATE_REQUESTED";
export const UPDATE_COMPLETED = "projectPermissions/UPDATE_COMPLETED";
export const UPDATE_FAILED = "projectPermissions/UPDATE_FAILED";

export const DELETE_REQUESTED = "projectPermissions/DELETE_REQUESTED";
export const DELETE_COMPLETED = "projectPermissions/DELETE_COMPLETED";
export const DELETE_FAILED = "projectPermissions/DELETE_FAILED";

export const FETCH_LIST_REQUESTED = "projectPermissions/FETCH_LIST_REQUESTED";
export const FETCH_LIST_COMPLETED = "projectPermissions/FETCH_LIST_COMPLETED";
export const FETCH_LIST_FAILED = "projectPermissions/FETCH_LIST_FAILED";

export const FETCH_DETAILS_REQUESTED = "projectPermissions/FETCH_DETAILS_REQUESTED";
export const FETCH_DETAILS_COMPLETED = "projectPermissions/FETCH_DETAILS_COMPLETED";
export const FETCH_DETAILS_FAILED = "projectPermissions/FETCH_DETAILS_FAILED";

export const RESET_LIST = "projectPermissions/RESET_LIST";
